/**
 * convertQueryString
 * @description Convert query object to query string
 * 
 * @param baseURL 
 * @param query 
 * @returns 
 */



export type Operator = "eq" | "gt" | "lt" | "gte" | "lte" | "in" | "btw" 
export type FilterObjecItem<T> = {
    values: string[] | number[] | boolean[]
    operator: Exclude<Operator, "btw">
    attribute: keyof T
} | {
    values: [number, number] | [string, string]
    operator: "btw"
    attribute: keyof T
}



export type FilterObject<T> = {
    [K in keyof T]?: FilterObjecItem<T>
}


export type OperatorQuery = 
  | `<${string}`
  | `>${string}`
  | `<=${string}`
  | `>=${string}`
  | `<<${string}`
  | `>>${string}`
  | `<in>[${string}]`
  | `<<in>>[${string}]`
  | `=${string}`
  | `==${string}`
  | `<<btw>>[${number | string},${number | string}]`
  | undefined


export const convertFilterObjectOperatorToQueryOperator = (operator?: Operator,value?: number[] | string[] | boolean[]) : OperatorQuery => {
    
    if (value?.length === 0 || value === undefined || value === null ){
        return undefined
    }
    const valueType = typeof value[0]
    if ((valueType === "number")){
        switch (operator){
            case "eq":
                return `==${value[0]}`
            case "gt":
                return `>>${value[0]}`
            case "lt":
                return `<<${value[0]}`
            case "gte":
                return `>>=${value[0]}`
            case "lte":
                return `<<=${value[0]}`
            case "in":
                return `<<in>>[${value.join(',')}]`
            case "btw":
                if (value.length < 2){
                    return undefined
                }
                return `<<btw>>[${value[0]},${value[1]}]`
            
            default:
                return `==${value[0]}`
        }

    }

    if (valueType === "string"){
        switch (operator){
            case "eq":
                return `=${value[0]}`
            case "gt":
                return `>${value[0]}`
            case "lt":
                return `<${value[0]}`
            case "gte":
                return `>=${value[0]}`
            case "lte":
                return `<=${value[0]}`
            case "in":
                return `<in>[${value.join(',')}]`
            case "btw":
                return `<btw>[${value[0]},${value[1]}]`
            
            default:
                return `=${value[0]}`
        }
    }

    if (valueType === "boolean") {
        return `==${value[0]}`
    }

}


export const convertFilterObjectToWhereQuery = <T>(filter?: FilterObject<T>) => {

    if (filter === undefined || filter === null) {  return undefined }
    return Object.keys(filter).reduce<string[]>((prev, key) =>{
        const typedKey = key as keyof T;
        const operator = filter[typedKey]?.operator as Operator
        const value = filter[typedKey]?.values as string[] | number[]
        const queryOperator = convertFilterObjectOperatorToQueryOperator(operator, value)
        if (!queryOperator){
            return prev
        }
        return [...prev, `${key}${queryOperator}`]
    } ,[]).join('|');
}

export const convertFilterObjectToRawFilter = <T>(filter?: FilterObject<T>) => {
    if (filter === undefined || filter === null) {  return undefined }
   const result = Object.keys(filter).reduce<{[key:string]: string}>((prev, key) =>{
        const typedKey = key as keyof T;
        if (!filter[typedKey]){
            return prev
        }
        const operator = filter[typedKey]?.operator
        const value = filter[typedKey]?.values
        const queryOperator = convertFilterObjectOperatorToQueryOperator(operator as Operator, value)
        if (!queryOperator){
            return prev
        }
        return {...prev, [key]: queryOperator}
    } ,{});

    return result
}

export const extractRawOperation = (value: string) => {
    if (value.includes("<<btw>>")){
        return "<<btw>>"
    }else
    if (value.includes("<btw>")){
        return "<btw>"
    }else
    if (value.includes("<<in>>")){
        return "<<in>>"
    }else if (value.includes("<in>")){
        return "<in>"
    }
    else if (value.includes("<<")){
        return "<<"
    }else if (value.includes(">>")){
        return ">>"
    }else if (value.includes("<=")){
        return "<="
    }else if (value.includes(">=")){
        return ">="
    }else if (value.includes("<")){
        return "<"
    }else if (value.includes(">")){
        return ">"
    }else if (value.includes("==")){
        return "=="
    }else if (value.includes("=")){
        return "="
    }

}

export const convertWhereQueryToFilterObject = <T>(whereQuery?: string | null) => {
    if (whereQuery === undefined || whereQuery === null) { return undefined }
    const filter = whereQuery.split('|').reduce<{[key:string]: FilterObjecItem<T>}>((prev, current) => {
        const keyStr = extractRawOperation(current)
        if (!keyStr){
            return prev
        }

        const [key, value] = current.split(keyStr);
        const typedKey = key as keyof T;
        const operator = keyStr as Operator


        const valueStr = value

        if (!operator || !valueStr){
            return prev
        }
        const values = valueStr.split(',')

        return {...prev, [typedKey]: {operator: operator as Operator, values, attribute: typedKey} as FilterObjecItem<T>}
    }, {})
    return filter
}



export const convertQueryString = (baseURL: string, query: {[key:string]: string }) => {
    const queryString = Object.keys(query).reduce<string[]>(
        (prev, key) => { 
            if (query[key] === undefined || query[key] === null) { return prev }
            return [...prev, key + '=' + query[key]]}, []).join('&');
    return baseURL + '?' + queryString;
}

export const convertFilterToWhereQuery = (filter: any) => {
    if (filter === undefined || filter === null) {  return undefined }

    return Object.keys(filter).reduce<string[]>((prev, key, i) =>{
   
        if (!filter[key]){
            return prev
        }
        if (filter[key] === undefined || filter[key] === null || filter[key]=== "") { 
   
            return prev 
        }else{
            return [...prev, `${key}${filter[key]}`]
        }
    } ,[]).join('|');
}


export const convertFormWhereQueryToFilterObject = (whereQuery?: string | null) => {
    if (whereQuery === undefined || whereQuery === null) { return undefined }
    const filter = whereQuery.split('|').reduce<{[key:string]: string}>((prev, current) => {
        const [key, value] = current.split('=');
        return {...prev, [key]: value}
    }, {})
    return filter
}

